module.exports = __webpack_public_path__ + "media/images/flags/1x1/kwt-db5c1f04d09ed7db2dbb7fed08282fcb.svg";